<template>
  <div class="commentPageContainer">
    <!--Commenter-->
        <div v-if="isLoading">Loading comments...</div>
        <div v-else>
          <!-- User comments widget -->
          <div class="commentContainer">
              <v-data-table
                :headers="commentHeaders"
                :items="posts"
                :items-per-page="20"
                class="transparent">
                <template v-slot:item="comment">
                  <tr>
                    <td colspan="5">
                      <v-card
                        class="mx-auto"
                        color="#889A9A"
                        dark
                      >
                        <v-card-text class="headline black--text">
                          {{ comment.item.content }}
                        </v-card-text>

                        <v-card-actions>
                          <v-list-item class="grow">
                            <span v-html="generateSetImage(comment.item.multiverseId)"></span>

                            <v-list-item-content>
                              <v-list-item-title class="black--text">{{ comment.item.postedBy }}</v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-content>
                              <v-list-item-title class="black--text">{{ comment.item.gathererDate }}</v-list-item-title>
                            </v-list-item-content>

                            <v-row
                              align="center"
                              justify="end"
                            >
                              <span class="subheading mr-2">{{ comment.item.rating }}</span>
                              <v-icon class="mr-1">
                                mdi-star
                              </v-icon>
                            </v-row>
                          </v-list-item>
                        </v-card-actions>
                      </v-card>
                    </td>
                  </tr>
                </template>
              </v-data-table>
          </div>
        </div>
        <!-- End user comments widget -->
        <!-- Comment widget -->
        <span v-if="posted" v-on:click="posted=false">{{ postResponse }}</span>
          <v-textarea
            v-model="content"
            color="black"
            background-color="#889A9A"
          ></v-textarea>
          Rating:
          <select v-model="rating">
            <option>0</option>
            <option>0.5</option>
            <option>1</option>
            <option>1.5</option>
            <option>2</option>
            <option>2.5</option>
            <option>3</option>
            <option>3.5</option>
            <option>4</option>
            <option>4.5</option>
            <option>5</option>
          </select>
          <a @click.stop="postComment()" class="button is-primary">Add Comment</a>
        <!-- End Comment widget -->
  </div>
</template>
<script>
import axios from 'axios'
import store from '../store'
import { API_BASE_URL } from '../config'

export default {
    data() {
        return {
            isLoading: true,
            posts: {},
            posted: false,
            postResponse: '',
            allPosts: {},
            username: '',
            content: '',
            rating: 0,
            postId: '',
            printingSelectOptions: {
              itemsPerPage: 5
            },
            multiverseCards: {},
            commentHeaders: [
              {
                text: 'Posted By',
                align: 'start',
                value: 'postedBy'
              },
              {
                text: 'Date',
                value: 'gathererDate',
                sortable: true
              },
              {
                text: 'Rating',
                value: 'rating',
                sortable: true
              },
              {
                text: 'Content',
                value: 'content',
                sortable: false
              },
              /*{
                text: 'Sauce',
                value: 'url',
                sortable: true
              }*/
            ],
            cardHeaders: [
              {
                text: '',
                value: 'multiverseId'
              }
            ]
        }
    },
    async created () {
        this.unsubscribe = store.subscribe((mutation, state) => {
          if (mutation.type === 'updateFilteredPosts') {
            this.posts = state.posts
            this.allPosts = state.allPosts
            this.multiverseCards = state.multiverseCards
            this.isLoading = false
          }

          if (mutation.type === 'updatePosts') {
            this.posts = state.posts
            this.allPosts = state.allPosts
            this.multiverseCards = state.multiverseCards
            this.isLoading = false
          }
        })

        try {
          store.dispatch('fetchPosts', this.$route.query.card).then(() => {
            this.posts = store.state.allPosts
            this.allPosts = store.state.allPosts
            this.multiverseCards = store.state.multiverseCards
            this.isLoading = false
          })
        } catch (e) {
          // handle the authentication error here
        }
    },
    async sendComment () {

    },
    methods: {
      generateImageLink: function (card) {
        return 'https://api.scryfall.com/cards/' + card.setCode.toLowerCase() + '/' + card.number + '/en' + '/?format=image&version=png'
      },
      generateSetImage: function (multiverseId) {
        if (typeof this.multiverseCards.find === "function") {
          var result = this.multiverseCards.find(x => x.multiverseId == multiverseId);
          if (result != undefined) {
            var setCode = '<img src="/images/sets/' + result.setCode.toLowerCase() + '.svg">'
            return setCode
          } else {
            return ''
          }
        }
      },
      postComment: async function () {
        console.log('post')
        try {
            let config = {
              headers: {
                Authorization: 'Bearer ' + store.state.session
              }
            }
            const response = await axios.post(
              API_BASE_URL + '/post',
              {
                content: this.content,
                rating: this.rating,
                cardId: store.state.selectedCard.scryfallId
              },
              config
            )
            this.postResponse = response.data
            this.posted = true
        } catch (e) {
            // handle error posting comment here
        }
      }
    }
}
</script>
